import styled from 'styled-components';

export const SuccessMessage = styled.div`
  width: 521px;
  height: 321px;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 2px;

  img {
    width: 70px;
    height: 70px;
  }
  h1 {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #000;
    margin-top:29px;
  }
  p {
    color: #000;
  }
  button {
    margin-top:29px;
    width: 67px;
    height: 32px;
    background: #24a95d;
    outline:none;
    border: 1px solid #24a95d;
    color:#fff;
    cursor: pointer;
    &:hover{
      transform:scale(1.02)
    }
  }
`;
